<template>
  <NoodleBody />
</template>

<script>
import NoodleBody from '../molecules/NoodleBody.vue'


export default {
  name: 'NoodleView',
  components: {
    NoodleBody,
  }
}
</script>
